import { render, staticRenderFns } from "./withdraw-info.vue?vue&type=template&id=7cd2aff2&"
import script from "./withdraw-info.vue?vue&type=script&lang=js&"
export * from "./withdraw-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports